/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConditionGroupFromJSON, ApiConditionGroupToJSON, } from './ApiConditionGroup';
import { ApiLeadStatusTypeFromJSON, ApiLeadStatusTypeToJSON, } from './ApiLeadStatusType';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiLeadStatusRuleFromJSON(json) {
    return ApiLeadStatusRuleFromJSONTyped(json, false);
}
export function ApiLeadStatusRuleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asDefault': !exists(json, 'asDefault') ? undefined : json['asDefault'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'rules': !exists(json, 'rules') ? undefined : (json['rules'].map(ApiConditionGroupFromJSON)),
        'stageKey': !exists(json, 'stageKey') ? undefined : json['stageKey'],
        'stageOrder': !exists(json, 'stageOrder') ? undefined : json['stageOrder'],
        'type': !exists(json, 'type') ? undefined : ApiLeadStatusTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadStatusRuleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asDefault': value.asDefault,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'rules': value.rules === undefined ? undefined : (value.rules.map(ApiConditionGroupToJSON)),
        'stageKey': value.stageKey,
        'stageOrder': value.stageOrder,
        'type': ApiLeadStatusTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
